import dynamic from 'next/dynamic';
import type { SocialLinksProps } from '@/components/molecules/SocialLinks/SocialLinks';

export const SocialLinks = dynamic<SocialLinksProps>(
  () => import('./SocialLinks').then(mod => mod.SocialLinks),
  {
    ssr: false,
  }
);
